import { useEffect, useRef } from "react";
import { fetchTemplates, syncBarMetafields } from "../api/templatesApi";

/**
 * After install / app load, re-push DB bars → Shopify app metafields once.
 * Keeps storefront (metafield-only) aligned with the admin database.
 */
export function useSyncBarMetafieldAfterInstall(installChecked, installData) {
  const startedRef = useRef(false);

  useEffect(() => {
    const clientId = installData?.shop_info?.id;
    if (!installChecked || !clientId || startedRef.current) return;
    startedRef.current = true;

    let cancelled = false;

    (async () => {
      try {
        const listRes = await fetchTemplates();
        const rows = listRes?.data?.templates ?? [];
        if (!rows.length || cancelled) return;
        await syncBarMetafields();
      } catch (e) {
        console.warn("[useSyncBarMetafieldAfterInstall]", e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [installChecked, installData?.shop_info?.id]);
}
